import * as React from 'react';
import { FC } from 'react';

import { useIntl } from 'react-intl';

import IconCircleAlert from 'components/icons/circle-alert';
import { ServiceMode } from 'state/service-mode';

import {
  ReminderSubtitle,
  ReminderTitle,
  TextWrapper,
  Wrapper,
} from './cash-payment-reminder.styled';

interface ICashPaymentReminderProps {
  serviceMode: ServiceMode;
}

/**
 * Display a short message to remind customers to pay for their order in cash
 */
const CashPaymentReminder: FC<ICashPaymentReminderProps> = ({ serviceMode }) => {
  const { formatMessage } = useIntl();

  const subtitleKey =
    serviceMode === ServiceMode.DELIVERY ? 'uponOrderDelivery' : 'uponOrderPickup';

  return (
    <Wrapper data-testid="cash-payment-message">
      <IconCircleAlert width="20" />
      <TextWrapper>
        <ReminderTitle>{formatMessage({ id: 'pleaseHaveYourCashReady' })}</ReminderTitle>
        <ReminderSubtitle>{formatMessage({ id: subtitleKey })}</ReminderSubtitle>
      </TextWrapper>
    </Wrapper>
  );
};

export default CashPaymentReminder;
